export enum PhoneCallResult {
  MISSED = "missed",
  ANSWERED = "answered",
  DECLINED = "declined",
}
